import { Injectable , OnInit} from '@angular/core';
import { Http }       from '@angular/http';
 
import { Observable }     from 'rxjs/Observable';
import 'rxjs/add/operator/map';
 
import {Ticket} from './tickets-page/ticket';
import { LoginService } from 'app/login/login.service';


 
@Injectable()
export class LayoutService implements OnInit{

    migrationID:string;
    businessName: string;

    migration : any;

    updatedMigration:any;
    isEditing:boolean=false;


   public selectedTicket:Ticket;


 
  constructor(private http: Http, private loginService: LoginService) {}


  ngOnInit () {


  }

  

setMigrationID ( migration:any) {
      
    this.migrationID = migration;

    let migs: any []  = this.loginService.agent.migrations;



    for ( let i=0; i< migs.length; i++ ) {
        if ( migs[i].id === migration) {
            this.migration= migs[i];
            this.businessName =  migs[i].businessName;
            break;
            
        }
    }
      
  }

  setMigrationToBeEdited ( migrationIn: any) {
      this.updatedMigration = migrationIn;
      this.isEditing=true;

  }

  unsetMigrationToBeEdited () {
      this.updatedMigration=null;
      this.isEditing=false;
      
  }
getMigrationID () :string{

    return this.migration.id;

}


setMigration ( migration:any) {

    this.migration= migration;
    this.businessName = migration.businessName;
    this.migrationID = migration.id;
    

}
setMigrationNameAndID (name:string, id:string) {

    this.businessName = name;
    this.migrationID = id;

    
}

getMigrationName () : string  {


    return this.businessName;


}

}


// WEBPACK FOOTER //
// C:/Users/bishop.duperret.GOMURAL/Documents/ConciergeDashboard/gomural-mural-outlook-configuration-dashboard-43c2b5785cd3/src/app/layout/layout.service.ts